import React from 'react';
import styled from 'styled-components';

export const ErrorMsg = ({ error }) => (
  <Root><label>{ error }</label></Root>
);

export const Root = styled.div`
  margin-top: 26px;
  margin-bottom: 26px;
  label {
    padding: 10px;
    padding-left: 16px;
    padding-right: 16px;
    color: #566778;
    font-weight: 400;
    font-size: 16px;
    line-height: 40px;
    background-color: #FFE5E6;
  }
`;